import AOS from 'aos';
import 'aos/dist/aos.css';
import AboutMe from 'components/AboutMe';
import Footer from 'components/Footer';
import FullStack from 'components/FullStack';
import Header from 'components/Header';
import Hero from 'components/Hero';
import MyPortfolio from 'components/MyPortfolio';
import MyStack from 'components/MyStack';
import { useEffect } from 'react';
import './App.css';

function App() {
  useEffect(() => {
    AOS.init({ duration: 700, easing: 'ease-in-sine', delay: 100 });
  }, []);
  return (
    <>
      <main className='wrapper'>
        <Header />
        <Hero />
        <FullStack />
        <MyStack />
        <MyPortfolio />
        <AboutMe />
        <Footer />
      </main>
    </>
  );
}

export default App;
